import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props: any) => (
    <Svg
        width={props.size || 24}
        height={props.size || 24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            d="M7.5 18.9746C7.08333 18.9746 6.72917 18.8288 6.4375 18.5371C6.14583 18.2454 6 17.8913 6 17.4746V3.47461C6 3.05794 6.14583 2.70378 6.4375 2.41211C6.72917 2.12044 7.08333 1.97461 7.5 1.97461H18.5C18.9167 1.97461 19.2708 2.12044 19.5625 2.41211C19.8542 2.70378 20 3.05794 20 3.47461V17.4746C20 17.8913 19.8542 18.2454 19.5625 18.5371C19.2708 18.8288 18.9167 18.9746 18.5 18.9746H7.5ZM7.5 17.4746H18.5V3.47461H7.5V17.4746ZM4.5 21.9746C4.08333 21.9746 3.72917 21.8288 3.4375 21.5371C3.14583 21.2454 3 20.8913 3 20.4746V6.14961C3 5.93294 3.07083 5.75378 3.2125 5.61211C3.35417 5.47044 3.53333 5.39961 3.75 5.39961C3.96667 5.39961 4.14583 5.47044 4.2875 5.61211C4.42917 5.75378 4.5 5.93294 4.5 6.14961V20.4746H15.6C15.8167 20.4746 15.9958 20.5454 16.1375 20.6871C16.2792 20.8288 16.35 21.0079 16.35 21.2246C16.35 21.4413 16.2792 21.6204 16.1375 21.7621C15.9958 21.9038 15.8167 21.9746 15.6 21.9746H4.5ZM7.5 3.47461V17.4746V3.47461Z"
            fill={props.color || "#1D2939"}
        />
    </Svg>
);
export default SVGComponent;
